import React from 'react';
import card from '../../assets/card-1.png';
import { FaArrowRight } from 'react-icons/fa';


function App() {
  return (
    <div className="justify-center">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full p-12">
        <div className="bg-blue-500 flex items-center p-4 rounded-lg shadow-lg h-auto">
          <div className='flex flex-row items-center justify-start w-full'>
            <img src={card} className='w-1/3 h-36 object-cover' alt="Card-Image" />
            <div className='flex flex-col items-center justify-center ml-6 w-full'>
              <h2 className="text-lg text-white font-bold text-center">Optimum Fish <br />Food 3 in 1</h2>
              <a href="/aqua" className="mt-4 text-white flex items-center space-x-2">
                <span>Shop Now</span>
                <div className="w-8 h-8 bg-white text-blue-500 rounded-full flex items-center justify-center">
                  <FaArrowRight />
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="bg-blue-500 flex items-center p-4 rounded-lg shadow-lg h-auto">
          <div className='flex flex-row items-center justify-start w-full'>
            <img src={card} className='w-1/3 h-36 object-cover' alt="Card-Image" />
            <div className='flex flex-col items-center justify-center ml-6 w-full'>
              <h2 className="text-lg text-white font-bold text-center">PEDIGREE - RICE <br />Flavour Dog Foods</h2>
              <a href="/dogs" className="mt-4 text-white flex items-center space-x-2">
                <span>Shop Now</span>
                <div className="w-8 h-8 bg-white text-blue-500 rounded-full flex items-center justify-center">
                  <FaArrowRight />
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="bg-blue-500 flex items-center p-4 rounded-lg shadow-lg h-auto">
          <div className='flex flex-row items-center justify-start w-full'>
            <img src={card} className='w-1/3 h-36 object-cover' alt="Card-Image" />
            <div className='flex flex-col items-center justify-center ml-6 w-full'>
              <h2 className="text-lg text-white font-bold text-center">ME-O Jelly <br />Adult Ocean Fish</h2>
              <a href="/cats" className="mt-4 text-white flex items-center space-x-2">
                <span>Shop Now</span>
                <div className="w-8 h-8 bg-white text-blue-500 rounded-full flex items-center justify-center">
                  <FaArrowRight />
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="bg-blue-500 flex items-center p-2 rounded-lg shadow-lg h-auto">
          <div className='flex flex-row items-center justify-start w-full'>
            <img src={card} className='w-1/3 h-40 object-cover' alt="Card-Image" />
            <div className='flex flex-col items-center justify-center ml-6 w-full'>
              <h2 className="text-lg text-white font-bold text-center">Mynah <br />Bird Food</h2>
              <a href="/birds" className="mt-4 text-white flex items-center space-x-2">
                <span>Shop Now</span>
                <div className="w-8 h-8 bg-white text-blue-500 rounded-full flex items-center justify-center">
                  <FaArrowRight />
                </div>
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default App;
